<template>
  <main>
    <v-toolbar class="blue" app fixed dark>
      <v-toolbar-side-icon @click.stop="$root.$children[0]._data.drawer = !$root.$children[0]._data.drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-if="currentDataset.meta.name">Erfassung: {{ currentDataset.meta.name }}</v-toolbar-title>
      <v-toolbar-title v-else>Erfassung</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>search</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content v-if="currentDataset.meta.name">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 sm4 lg3>
            <v-layout row>
              <v-flex xs12>
                <search-datasets :loading="loadingDatasetIndicator" :datasetsMeta="datasetsMeta.data"></search-datasets>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <intelligent-metadata-scanner :show="metaDataUploadDialog"></intelligent-metadata-scanner>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm8 lg9>
            <v-card>
              <v-tabs centered grow dark>
                <v-tabs-bar class="cyan">
                  <v-tabs-item :href="'#default-view'" ripple>Vereinfachte Ansicht</v-tabs-item>
                  <v-tabs-item :href="'#expert-view'" ripple>Expertenansicht</v-tabs-item>
                  <v-tabs-slider class="yellow"></v-tabs-slider>
                </v-tabs-bar>

                <v-card-text v-if="loadingDatasetIndicator" style="height: 490px">
                  <v-progress-circular indeterminate class="loading-dataset-indicator"></v-progress-circular>
                </v-card-text>

                <v-tabs-items v-show="!loadingDatasetIndicator">
                  <v-tabs-content :id="'default-view'">
                    <v-card-title primary-title>
                      <div>
                        <div class="headline">Erfassung</div>
                        <div class="body-2 grey--text">Füllen Sie die Felder aus, um den Datensatz zu erfassen. Verwenden Sie die Expertenansicht, um mehrere Meta-Datensätze zu bearbeiten.</div>
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <!--
                      <v-layout row wrap>
                        <v-flex sm6 xs12 v-for="field in fields">
                          <v-text-field
                            v-if="field.type == 'text'"
                            :label="field.label[currentLanguage]"
                            :placeholder="field.description[currentLanguage]"
                          ></v-text-field>

                          <v-select
                            v-if="field.type == 'choice'"
                            v-bind:items="field.choices"
                            :label="field.label[currentLanguage]"
                            :hint="field.description[currentLanguage]"
                            item-text="name"
                            item-value="name"
                            persistent-hint
                            single-line
                            bottom
                            v-model="e"
                          >
                            <template slot="selection" slot-scope="data">
                              abc
                            </template>
                            <template slot="item" slot-scope="data">
                              babla
                            </template>
                          </v-select>
                        </v-flex>
                      </v-layout>
                      <br><br><br>
                      -->
                      <v-layout row>
                        <v-flex sm6>
                          <v-text-field label="Name des Datensatzes" v-model="currentDataset.meta.name"></v-text-field>
                        </v-flex>
                        <v-flex sm6>
                          <v-text-field label="Quelle" v-model="currentDataset.meta.source"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex sm6>
                          <v-dialog persistent lazy full-width>
                            <v-text-field slot="activator" v-model="currentDataset.meta.date.created" label="Erstellt am" prepend-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="currentDataset.meta.date.created" :first-day-of-week="0" locale="de-de" scrollable actions>
                              <template scope="{ save, cancel }">
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="save">Speichern</v-btn>
                                  <v-btn flat @click="cancel">Abbrechen</v-btn>
                                </v-card-actions>
                              </template>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>

                        <v-flex sm6>
                          <v-dialog persistent lazy full-width>
                            <v-text-field slot="activator" v-model="currentDataset.meta.date.modified" label="Zuletzt verändert" prepend-icon="event" readonly></v-text-field>
                            <v-date-picker v-model="currentDataset.meta.date.modified" :first-day-of-week="0" locale="de-de" scrollable actions>
                              <template scope="{ save, cancel }">
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="save">Speichern</v-btn>
                                  <v-btn flat @click="cancel">Abbrechen</v-btn>
                                </v-card-actions>
                              </template>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                      </v-layout>

                      <v-layout row>
                        <v-flex sm6>
                          <v-text-field label="Sprache" v-model="currentDataset.meta.language"></v-text-field>
                        </v-flex>
                        <v-flex sm6>
                          <v-text-field label="Ansprechpartner" v-model="currentDataset.meta.contact"></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-text-field label="Beschreibung des Datensatzes" hint="Geben Sie eine kurze Beschreibung des Datensatzes an" v-model="currentDataset.meta.description" multi-line></v-text-field>
                    </v-card-text>
                  </v-tabs-content>
                  <v-tabs-content :id="'expert-view'">
                    <v-card-title primary-title>
                      <div>
                        <div class="headline">Erfassung</div>
                        <div class="body-2 grey--text">Füllen Sie die Felder aus, um den Datensatz zu erfassen. Verwenden Sie die Expertenansicht, um mehrere Meta-Datensätze zu bearbeiten.</div>
                      </div>
                    </v-card-title>
                    <v-card-text>
                      <Spreadsheet :root="root" :settings="datasetsMeta"></Spreadsheet>
                    </v-card-text>
                  </v-tabs-content>
                </v-tabs-items>
              </v-tabs>
              <v-card-actions>
                <v-btn flat color="primary">Änderungen speichern</v-btn>
                <v-btn flat>Abbrechen</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

    <v-content v-else>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs12>
                <search-datasets :loading="loadingDatasetIndicator" :datasetsMeta="datasetsMeta.data" :show-hint="true"></search-datasets>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <intelligent-metadata-scanner :show="metaDataUploadDialog"></intelligent-metadata-scanner>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
          
  </main>
</template>

<script>
import Spreadsheet from 'vue-handsontable-official'
import IntelligentMetadataScanner from '@/components/IntelligentMetadataScanner'
import SearchDatasets from '@/components/SearchDatasets'

export default {
  computed: {
    currentDataset () {
      return this.$store.getters.getCurrentDataset
    },
    datasetsMeta () {
      return this.$store.getters.getDatasetsMeta
    },
    loadingDatasetIndicator () {
      return this.$store.getters.getLoadingDatasetIndicator
    }
  },
  components: {
    Spreadsheet,
    IntelligentMetadataScanner,
    SearchDatasets
  },
  data () {
    return {
      root: 'test-hot',
      metaDataUploadDialog: false,
      currentLanguage: 'de',
      e: [],
      element: [],
      fields: [
      /* eslint-disable */
        {
          "type": "text",
          "nodetype": "LITERAL",
          "property": "dcatde:contributorID",
          "cardinality": {
            "min": 1,
            "max": 1
          },
          "label": {
            "en":"Data identifier",
            "de": "Datenbereitsteller-ID"
          },
          "description": {
            "en": "A short title of the resource.",
            "de": "Ein kurzer Titel der Ressource."
          },
          "styles": ["nonEditable"]
        },
        {
          "type": "text",
          "nodetype": "LANGUAGE_LITERAL",
          "property": "dct:title",
          "cardinality": {
            "min": 1,
            "max": 1
          },
          "label": {
            "en": "Title",
            "de": "Titel"
          },
          "description": {
            "en": "A short title of the resource.",
            "de": "Ein kurzer Titel der Ressource."
          }
        },
        {
          "type": "text",
          "nodetype": "DATATYPE_LITERAL",
          "property": "dct:description",
          "cardinality": {
            "min": 1,
            "pref": "1",
            "max": 1
          },
          "label": {
            "en": "Description",
            "de": "Beschreibung"
          },
          "description": {
            "en": "A description for this resource.",
            "de": "Eine Beschreibung dieser Ressource."
          }
        },
        {
          "type": "text",
          "nodetype": "DATATYPE_LITERAL",
          "property": "dct:modified",
          "datatype": "xsd:date",
          "cardinality": {
            "min": 1,
            "pref": "1",
            "max": 1
          },
          "label": {
            "en": "Date",
            "de": "Datum"
          },
          "description": {
            "en": "A date when this resource was modified.",
            "de": "Ett datum när denna resurs modifierades."
          },
          "styles": [
            "autoUpdateDate",
            "nonEditable"
          ]
        },
        {
          "type": "text",
          "nodetype": "DATATYPE_LITERAL",
          "property": "dct:date",
          "datatype": "xsd:date",
          "cardinality": {
            "min": 1,
            "pref": "1",
            "max": 1
          },
          "label": {
            "en": "Date",
            "de": "Datum"
          },
          "description": {
            "en": "A date for this resource.",
            "de": "Ein Datum für diese Ressource."
          },
          "styles": ["autoInitDate"]
        },
        {
          "id": "subject",
          "type": "choice",
          "nodetype": "URI",
          "property": "http://publications.europa.eu/mdr/resource/authority/data-theme/xml/data-theme.xml",
          "cardinality": {
            "min": 1,
            "pref": "1",
            "max": 2
          },
          "choices": [
            {
              "value": "AGRI",
              "label": {
                "en": "Agriculture, fisheries, forestry and food",
                "de": "Landwirtschaft, Fischerei, Forstwirtschaft und Nahrungsmittel"
              }
            },
            {
              "value": "ECON",
              "label": {
                "en": "Economy and finance",
                "de": "Wirtschaft und Finanzen"
              }
            },
            {
              "value": "EDUC",
              "label": {
                "en": "Education, culture and sport",
                "de": "Bildung, Kultur und Sport"
              }
            },
            {
              "value": "ENER",
              "label": {
                "en": "Energy",
                "de": "Energie"
              }
            },
            {
              "value": "ENVI",
              "label": {
                "en": "Environment",
                "de": "Umwelt"
              }
            },
            {
              "value": "GOVE",
              "label": {
                "en": "Government and public sector",
                "de": "Regierung und öffentlicher Sektor"
              }
            },
            {
              "value": "HEAL",
              "label": {
                "en": "Health",
                "de": "Gesundheit"
              }
            },
            {
              "value": "INTR",
              "label": {
                "en": "International issues",
                "de": "Internationale Themen"
              }
            },
            {
              "value": "JUST",
              "label": {
                "en": "Justice, legal system and public safety",
                "de": "Justiz, Rechtssystem und öffentliche Sicherheit"
              }
            },
            {
              "value": "REGI",
              "label": {
                "en": "Regions and cities",
                "de": "Regionen und Städte"
              }
            },
            {
              "value": "SOCI",
              "label": {
                "en": " Population and society",
                "de": "Bevölkerung und Gesellschaft"
              }
            },
            {
              "value": "TECH",
              "label": {
                "en": "Science and technology",
                "de": "Wissenschaft und Technologie"
              }
            },
            {
              "value": "TRAN",
              "label": {
                "en": "Transport",
                "de": "Verkehr"
              }
            }
          ],
          "label": {
            "en": "Subject",
            "de": "Thema"
          },
          "description": {
            "en": "A subject for this resource.",
            "de": "Eine Thema für diese Ressource."
          }
        },
        {
          "type": "choice",
          "nodetype": "URI",
          "property": "http://purl.org/dc/terms/license",
          "cardinality": {
            "min": 1,
            "pref": 1,
            "max": 1
          },
          "choices": [
            {
              "value": "cc:by/4.0/",
              "label": {
                "en": "CC BY 4.0 (Attribution)"
              }
            }, {
              "value": "cc:by-nc/4.0/",
              "label": {
                "en": "CC BY-NC 4.0 (Attribution, Non-Commercial)"
              }
            }],
          "styles": ["verticalRadioButtons"],
          "label": {
            "en": "License",
            "de": "Lizenz"
          },
          "description": {
            "en": "A license for this resource.",
            "de": "Eine Lizenz für diese Ressource."
          }
        }
      ]
    }
  },
  methods: {
  }
}
</script>

<style>
#test-hot {
  height: 400px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/Erfassung.vue